<template>
    <div class="menu menu-sub menu-sub-dropdown w-250px w-md-300px" data-kt-menu="true">
        <div class="px-7 py-5">
            <div class="fs-5 text-dark fw-bolder">{{ $t('filters.title') }}</div>
        </div>

        <div class="separator border-gray-200"></div>

        <div class="px-7 py-5 overflow-auto max-h-300px">
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.product.id') }}:</label>
                <div>
                    <el-input v-model="filterData.id" oninput="value=value.replace(/[^0-9.]/g,'')"/>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.product.name') }}:</label>
                <div>
                    <el-input v-model="filterData.name" type="text"/>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.product.code') }}:</label>
                <div>
                    <el-input v-model="filterData.code" type="text"/>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.product.product_type_id') }}:</label>
                <div>
                    <el-select v-model="filterData.product_type_id" class="w-100" :placeholder="$t('common.chooseSelect')" clearable>
                        <el-option :value="1" :label="$t('pages.ecommerce.product.types[0]')"></el-option>
                        <el-option :value="2" :label="$t('pages.ecommerce.product.types[1]')"></el-option>
                        <el-option :value="3" :label="$t('pages.ecommerce.product.types[2]')"></el-option>
                        <el-option :value="4" :label="$t('pages.ecommerce.product.types[3]')"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.product.target_type') }}:</label>
                <div>
                    <el-select v-model="filterData.target_type" class="w-100" :placeholder="$t('common.chooseSelect')" clearable>
                        <el-option value="COMPANY" :label="$t('common.company')"></el-option>
                        <el-option value="CUSTOMER" :label="$t('common.customer')"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.product.active') }}:</label>
                <div>
                    <el-select v-model="filterData.active" class="w-100" :placeholder="$t('common.chooseSelect')" clearable>
                        <el-option :value="true" :label="$t('common.active')"></el-option>
                        <el-option :value="false" :label="$t('common.passive')"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.product.with_trashed') }}:</label>
                <div>
                    <el-switch v-model="filterData.with_trashed" :active-value="1" :inactive-value="undefined"/>
                </div>
            </div>
        </div>

        <div class="separator border-gray-200"></div>

        <div class="px-7 py-5">
            <div class="d-flex justify-content-end">
                <button type="reset" v-on:click="onReset" class="btn btn-sm btn-white btn-active-light-primary me-2" data-kt-menu-dismiss="true">{{ $t('btn.reset') }}</button>
                <button type="submit" v-on:click="onFilter" class="btn btn-sm btn-primary" data-kt-menu-dismiss="true">{{ $t('btn.apply') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProductFilter",
    data() {
        return {
            filterData: {}
        }
    },
    methods: {
        onReset() {
            this.filterData = {};
            this.onFilter();
        },
        onFilter() {
            this.$emit('onFilter', this.filterData);
        },
    }
}
</script>
